var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "343",
        height: "71",
        viewBox: "0 0 343 71",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { filter: "url(#filter0_di_1614_80106)" } }, [
        _c("rect", {
          attrs: {
            x: "4",
            y: "2",
            width: "335",
            height: "63",
            rx: "31.5",
            fill: "black",
            "fill-opacity": "0.3",
            "shape-rendering": "crispEdges",
          },
        }),
      ]),
      _c("defs", [
        _c(
          "filter",
          {
            attrs: {
              id: "filter0_di_1614_80106",
              x: "0",
              y: "0",
              width: "343",
              height: "71",
              filterUnits: "userSpaceOnUse",
              "color-interpolation-filters": "sRGB",
            },
          },
          [
            _c("feFlood", {
              attrs: { "flood-opacity": "0", result: "BackgroundImageFix" },
            }),
            _c("feColorMatrix", {
              attrs: {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha",
              },
            }),
            _c("feOffset", { attrs: { dy: "2" } }),
            _c("feGaussianBlur", { attrs: { stdDeviation: "2" } }),
            _c("feComposite", { attrs: { in2: "hardAlpha", operator: "out" } }),
            _c("feColorMatrix", {
              attrs: {
                type: "matrix",
                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0",
              },
            }),
            _c("feBlend", {
              attrs: {
                mode: "normal",
                in2: "BackgroundImageFix",
                result: "effect1_dropShadow_1614_80106",
              },
            }),
            _c("feBlend", {
              attrs: {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_dropShadow_1614_80106",
                result: "shape",
              },
            }),
            _c("feColorMatrix", {
              attrs: {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha",
              },
            }),
            _c("feOffset", { attrs: { dy: "6" } }),
            _c("feGaussianBlur", { attrs: { stdDeviation: "3" } }),
            _c("feComposite", {
              attrs: {
                in2: "hardAlpha",
                operator: "arithmetic",
                k2: "-1",
                k3: "1",
              },
            }),
            _c("feColorMatrix", {
              attrs: {
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0",
              },
            }),
            _c("feBlend", {
              attrs: {
                mode: "normal",
                in2: "shape",
                result: "effect2_innerShadow_1614_80106",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }